import api from '../api'
import { axios as $http } from 'cm'
import {
  throttle,
  debounce
} from '../../../../public-resource/libs/utils/index'
import Bridge from '../../../../frontend-lib/lib/Bridge'
import rankContainer from './rankContainer'

let IS_APP = window.$platform.isYixinliApp
// let IS_IOS = window.$platform.isiOS || window.$platform.isiPhone
let myBridge = new Bridge()

class TopicList {
  constructor(token) {
    this.token = token
    this.loading = false
    this.newRecentsList = []
    this.topicsList = [[]]
    this.hasRenderTag = false
    this.tagsList = [{ id: -1, name: '全部' }]
    this.page = [1]
    this.hasShowAll = [false]
    this.scrollTo = [0]
    this.activeIdx = 0

    this.promiseStack = []

    this.renderSearchEntry()
    this.renderFixedDom()

    this.getNewRecents()
    this.getListData()
    this.bindEvent()

    this.renderSearchInput = this.initSearchInput()

    window.yxl.stat.send({
      name: '故事集-页面访问',
      properties: {
        href: window.location.href,
        页面: '故事集tab页'
      }
    })
  }
  getNewRecents() {
    let params = {
      page: 1,
      size: 2
    }
    $http
      .get(api.getNewRecents, {
        params
      })
      .then(res => {
        res = res.data
        if (+res.code === 0) {
          this.newRecentsList = res.data.slice(0, 2)
          if (
            this.activeIdx === 0 &&
            this.hasRenderTag &&
            this.newRecentsList.length
          ) {
            this.renderNewRecents()
          }
        }
      })
  }
  getListData(isFirst) {
    let activeIdx = this.activeIdx
    if (this.loading || this.hasShowAll[activeIdx]) return
    this.loading = true
    $('.loading-more').show()

    this.topicsList[activeIdx] || (this.topicsList[activeIdx] = [])
    let page = this.page[activeIdx] || (this.page[activeIdx] = 1)
    let params = {
      token: this.token,
      tag_id: this.tagsList[activeIdx].id,
      page,
      size: 10
    }

    $http
      .get(api.getTopicsList, {
        params
      })
      .then(res => {
        res = res.data
        this.loading = false
        $('.loading-more').hide()
        if (+res.code === 0) {
          res = res.data
          this.page[activeIdx]++

          let tagsList = res.tags
          if (!this.hasRenderTag && tagsList.length) {
            this.tagsList = tagsList
            this.renderTag()
            this.hasRenderTag = true
          }

          if (!res.lists.length) {
            this.hasShowAll[activeIdx] = true
          }
          this.topicsList[activeIdx].push(...res.lists)
          this.renderList()
          if (isFirst) {
            $('.topicsWrap')[0].scrollTop = 0
          }
        } else {
          window.toast(res.message)
        }
      })
      .catch(() => {
        this.loading = false
        $('.loading-more').hide()
      })
  }
  renderTag() {
    let tags = ''
    this.tagsList.forEach((item, index) => {
      if (index) {
        tags += `<li>${item.name}</li>`
      } else {
        tags += `<li class="active">${item.name}</li>`
      }
    })
    $('.topicsWrap .tabNav ul').html(tags)
  }
  newRecentsTemplate(data) {
    return `
      <li class="detailItem">
        <a href="${api.host}/qa/real_time_story_detail/${data.story_id}">
          <img src="${data.avatar}" alt="${data.avatar}" class="avatar" />
          <div class="wrap">
            <div class="other">
              <span class="tag">#${data.topic_name}</span>
              <span class="join">${data.join_num}人参加</span>
            </div>
            <div class="content">
              ${data.content}
            </div>
            <div class="showAll">看全文</div>
          </div>
        </a>
      </li>
    `
  }
  newRecentsSwith() {
    $('.topicsWrap .detailItem').each((index, e) => {
      let el = $(e).find('.content')[0]
      if (
        (el.firstElementChild && el.firstElementChild.tagName === 'IMG') ||
        el.scrollHeight > $(el).height()
      ) {
        $($(e).find('.showAll')[0]).show()
      }
    })
  }
  renderNewRecents() {
    let newRecentsList = ''
    this.newRecentsList.forEach(item => {
      newRecentsList += this.newRecentsTemplate(item)
    })
    $('.topicsWrap .topicsList').prepend(newRecentsList)
    this.newRecentsSwith()
  }
  renderList() {
    let list = ''
    if (this.activeIdx === 0 && this.newRecentsList.length) {
      this.newRecentsList.forEach(item => {
        list += this.newRecentsTemplate(item)
      })
    }
    list += this.renderTopicTemplate(
      this.topicsList[this.activeIdx],
      this.tagsList[this.activeIdx].id
    )
    $('.topicsWrap .topicsList').html(list)
    if (this.activeIdx === 0 && this.newRecentsList.length) {
      this.newRecentsSwith()
    }
  }
  renderTopicTemplate(topicsList, tagId = '-2') {
    let template = ''
    topicsList.forEach(item => {
      template += `
        <li
          class="topicsListItem"
          style="background: url('${
            item.cover
          }') center center / cover no-repeat">
          <a href="${api.host}/qa/real_time_topics_detail/${item.topic_id}">
            <h2 class="title">#${item.topic_name}</h2>
            <p class="story">
              <span class="story-num">${item.story_num}个${
        item.topic_type === 'writing' ? '笔记' : '故事'
      }</span>
              <span class="story-tag">#${item.tag_name}</span>
              ${
                tagId == -2 && item.topic_type
                  ? `
                  <span class="story-type ${
                    item.topic_type === 'writing' ? 'write' : ''
                  }">${
                      item.topic_type === 'writing' ? '书写计划' : '故事集'
                    }</span>
                `
                  : ''
              }
            </p>
            ${
              JSON.stringify(item.last_story) !== '{}'
                ? `
                <p class="play-share">
                  <i class="play-icon"></i>
                  <span>${item.last_story.before}，${item.last_story.nickname}分享了他的故事</span>
                </p>
              `
                : ''
            }
          </a>
        </li>
      `
    })
    return template
  }
  renderFixedDom() {
    let tags = ''
    this.tagsList.forEach((item, index) => {
      if (index) {
        tags += `<li>${item.name}</li>`
      } else {
        tags += `<li class="active">${item.name}</li>`
      }
    })
    $('.topicsWrap').prepend(`
    <div class="topicsWrap-fixed-box">
      <div class="tabBar">
        <span class="active">话题</span>
        <span>书写榜</span>
      </div>
      <div class="searchEntry">
        <p class="text">输入关键词，搜索故事集</p>
      </div>
      <div class="tabNav">
        <ul>${tags}
        </ul>
      </div>
    </div>
  `)
  }

  renderSearchEntry() {
    $('.topicsWrap').prepend(`
      <div class="searchEntry">
        <p class="text">输入关键词，搜索故事集</p>
          </div>
      `).prepend(`
      <div class="tabBar">
          <span class="active">话题</span>
          <span>书写榜</span>
        </div>
      `)
  }
  initSearchInput() {
    let $input, $searchTip
    let that = this
    function reset() {
      that.$topicWrap.html($searchTip)
      $input.val('')
      $input.focus()
      that.promiseStack = []
    }
    return function() {
      if ($('.topicsWrap .searchPage').length) {
        $('.topicsWrap .searchPage').show()
        reset()
      } else {
        let $searchPage = $('<div class="searchPage"></div>')
        let $header = $('<div class="header"></div>')
        let $goback = $('<span class="icon-m-left"></span>')
        $input = $('<input type="text" placeholder="输入关键词，搜索故事集" />')
        let $cancel = $('<span class="cancel">取消</span>')
        let $topicWrap = (this.$topicWrap = $('<ul class="topicWrap"></ul>'))
        $searchTip = $('<li class="searchTip">每个人，都有自己的故事～</li>')
        $header
          .append($goback)
          .append($input)
          .append($cancel)
        $topicWrap.append($searchTip)
        $searchPage.append($header).append($topicWrap)
        $('.container').append($searchPage)
        $input.focus()

        $input.on(
          'input',
          debounce(this.getTopicsListBySearchWord.bind(this), 200)
        )
        $goback.on('click', function() {
          $searchPage.hide()
        })
        $cancel.on('click', () => {
          reset()
        })
      }
    }
  }
  isLatestRequest(promise) {
    return this.promiseStack[this.promiseStack.length - 1] === promise
  }
  async getTopicsListBySearchWord(e) {
    let $this = $(e.target)
    let searchWord = $this.val().trim()
    $this.val(searchWord)
    if (!searchWord) return

    let params = {
      title: searchWord
    }
    const promise = $http.get(api.getTopicsListBySearchWord, {
      params
    })
    this.promiseStack.push(promise)

    try {
      const { data: res } = await promise
      if (this.isLatestRequest(promise)) {
        const { code, data } = res
        if (code === 0) {
          let topicsList = data.lists
          if (topicsList.length) {
            this.$topicWrap.html(this.renderTopicTemplate(topicsList))
          } else {
            this.$topicWrap.html(
              '<li class="searchTip">没有找到你想要的结果～</li>'
            )
          }
        }
      }
    } catch (err) {
      if (this.isLatestRequest(promise)) {
        console.log(err)
        this.$topicWrap.html(
          '<li class="searchTip">没有找到你想要的结果～</li>'
        )
      }
    }
  }
  bindEvent() {
    let that = this

    $(document).delegate('.topicsWrap .tabNav li', 'click', function(e) {
      let $this = $(this)
      if ($this.hasClass('active')) return

      // $this
      //   .addClass('active')
      //   .siblings()
      //   .removeClass('active')
      that.scrollTo[that.activeIdx] = $('.topicsWrap')[0].scrollTop
      that.activeIdx = $this.index()
      $('.topicsWrap .topicsWrap-fixed-box .tabNav li')
        .eq(that.activeIdx)
        .addClass('active')
        .siblings()
        .removeClass('active')
      $('.topicsWrap>.tabNav li')
        .eq(that.activeIdx)
        .addClass('active')
        .siblings()
        .removeClass('active')
      if (that.topicsList[that.activeIdx]) {
        that.renderList()
        $('.topicsWrap')[0].scrollTop = that.scrollTo[that.activeIdx] || 0
      } else {
        $('.topicsWrap')[0].scrollTop = 0
        that.getListData(true)
      }

      window.yxl.stat.send({
        name: '故事集-交互行为',
        properties: {
          页面: '问答首页',
          行为: '点击',
          对象: '分类标签',
          文字: $this.text()
        }
      })
    })

    $(document).delegate(
      '.topicsWrap .topicsListItem, .topicsWrap .detailItem',
      'click',
      function(e) {
        e.preventDefault()
        let $this = $(this)
        let url = $this.children('a').attr('href')

        if ($this.hasClass('detailItem')) {
          window.yxl.stat.send({
            name: '故事集-交互行为',
            properties: {
              页面: '问答首页',
              行为: '点击',
              对象: '两个置顶故事',
              话题: $this
                .find('.tag')
                .text()
                .slice(1)
            }
          })
        }

        if (IS_APP) {
          myBridge.call('openWebView', {
            url,
            hideNavigationBar: 1,
            isCurrentPageOpen: 0
          })
        } else {
          window.open(url)
        }
      }
    )

    $('.topicsWrap .tabBar span').on('click', function() {
      let $this = $(this)
      let currIdx = $this.index()
      if (currIdx) {
        window.yxl.stat.send({
          name: '故事集-交互行为',
          properties: {
            页面: '问答首页',
            行为: '点击',
            对象: '书写榜'
          }
        })
        $('.topicsWrap').hide()
        if ($('.rankContainer').length > 0) {
          $('.rankContainer').show()
        } else {
          new rankContainer(this.token)
        }
      }
    })

    $(document).delegate('.topicsWrap .searchEntry', 'click', () => {
      this.renderSearchInput()
      window.yxl.stat.send({
        name: '故事集-交互行为',
        properties: {
          页面: '问答首页',
          行为: '点击',
          对象: '顶部搜索框'
        }
      })
    })

    let recordScrollTop = 0
    let scroll = throttle(function() {
      // console.log($(this).innerHeight(), $(this).scrollTop(), this.scrollHeight)
      let height = $(this).innerHeight()
      let scrollHeight = this.scrollHeight
      let scrollTop = $(this).scrollTop()

      if (scrollTop > 0 && height + scrollTop > scrollHeight - 20) {
        that.getListData()
      }
      if (scrollTop < 150) {
        if (scrollTop === 0) {
          $('.topicsWrap-fixed-box').hide()
        }
      } else if (scrollTop > recordScrollTop) {
        console.log('slideUp')
        $('.topicsWrap-fixed-box').slideUp()
      } else {
        $('.topicsWrap-fixed-box').slideDown()
      }

      recordScrollTop = scrollTop
    }, 500)
    $('.topicsWrap').on('scroll', scroll)
  }
}

module.exports = TopicList



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/modules/topicList.js